import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@auctisync/ui';
import { Link } from 'react-router-dom';
import { ForgotPasswordForm } from '../../components/ForgotPasswordForm';
import { authRedirectUrl } from '../../lib/authRedirect';

export function SuperForgotPassword() {
  return (
    <main
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
      }}
    >
      <Card style={{ width: '100%', maxWidth: '28rem' }}>
        <CardHeader>
          <CardTitle>Reset your password</CardTitle>
          <CardDescription>AuctiSync platform ops only. All actions are logged.</CardDescription>
        </CardHeader>
        <CardContent>
          <ForgotPasswordForm
            resetRedirectTo={authRedirectUrl('/auth/callback?next=/auth/reset-password')}
          />
          <div style={{ marginTop: '1rem', fontSize: '0.875rem' }}>
            <Link to="/super" style={{ color: 'var(--brand-primary)' }}>
              ← Back to sign-in
            </Link>
          </div>
        </CardContent>
      </Card>
    </main>
  );
}
